import _ from "lodash";
import { isNoiBai } from "../../course-staff/utils";
import { requestStatus } from "../../../../../constants";


//chỉ lấy ra phòng ban đã completed
function filterRequest(request: any): any[] {

  try {
    const fields = request.fields;
    const eContent = JSON.parse(fields.eContent);
    const departments = JSON.parse(fields.eSubRequestsStatus);

    const acceptedDepartment: string[] = [];

    for (const department of Object.keys(departments)) {
      if (departments[department].status === requestStatus.completed) {
        acceptedDepartment.push(department);
      }
    }

    const newContent = [];
    for (const content of eContent) {
      if (acceptedDepartment.includes(content.unit)) {
        newContent.push(content);
      }
    }

    request = {
      ...request,
      fields: { ...fields, eContent: JSON.stringify(newContent) },
    };

    return request;
  } catch (error) {
    return [];
  }
}

export function parseData(requests: any): any[] {
  const requests2 = _.cloneDeep(requests);

  const final2: any[] = [];
  for (const iterator of requests2) {
    final2.push(filterRequest(iterator));
  }
  
  const result = [];

  for (const request of final2) {
    try {
      const eContent = JSON.parse(request.fields.eContent);

      if (_.isArray(eContent)) {
        for (const content of eContent) {
          result.push({
            ...request,
            ...request.fields,
            ...content,
          });
        }
      }
    } catch (error) {}
  }

  const finalResult = _.chain(result)
    .groupBy("eMajor")
    .toPairs()
    .map((pair) => _.zipObject(["eMajor", "data"], pair))
    .value();

  return finalResult;
}

interface IIGroupedRequest {
  data: any[];
  eMajor: string;
}

export function groupByDepartment(groupedByEmajorRequests: IIGroupedRequest[]) {
  const NBRequests = [];
  const TSNRequests = [];

  for (const request of groupedByEmajorRequests) {
    for (const req of request.data) {
      if (isNoiBai(req.eDepartment)) NBRequests.push(req);
      else TSNRequests.push(req);
    }
  }

  return {
    NB: NBRequests,
    TSN: TSNRequests,
  };
}

export function mergeRequests(requests: any[]) {

  if (requests.length === 0 || !requests) return [];

  let data: any[] = [];

  for (const request of requests) {
    data = [...data, ...request.data];
  }

  return [{
    ...requests[0],
    data:data
  }];
}